import React from "react";
import {
  FaAddressBook,
  FaChartBar,
  FaClipboardCheck,
  FaClock,
  FaExclamationTriangle,
  FaFileAlt,
  FaListUl,
  FaMoneyBillWave,
  FaUserGraduate,
  FaUsers,
} from "react-icons/fa";

const iconForTab = (key = "") => {
  const normalized = key.toLowerCase();
  if (normalized.includes("metric") || normalized.includes("overview") || normalized.includes("summary")) return FaChartBar;
  if (normalized.includes("fee") || normalized.includes("invoice") || normalized.includes("payroll")) return FaMoneyBillWave;
  if (normalized.includes("parent") || normalized.includes("contact")) return FaAddressBook;
  if (normalized.includes("teacher")) return FaUsers;
  if (normalized.includes("admission")) return FaUserGraduate;
  if (normalized.includes("conflict")) return FaExclamationTriangle;
  if (normalized.includes("schedule")) return FaClock;
  if (normalized.includes("permission")) return FaClipboardCheck;
  if (normalized.includes("notification")) return FaFileAlt;
  return FaListUl;
};

const tones = {
  emerald: { active: "bg-emerald-500 text-white shadow-emerald-200", idle: "hover:bg-emerald-50 hover:text-emerald-700" },
  amber: { active: "bg-amber-500 text-white shadow-amber-200", idle: "hover:bg-amber-50 hover:text-amber-700" },
  indigo: { active: "bg-indigo-500 text-white shadow-indigo-200", idle: "hover:bg-indigo-50 hover:text-indigo-700" },
  sky: { active: "bg-sky-500 text-white shadow-sky-200", idle: "hover:bg-sky-50 hover:text-sky-700" },
};

export default function AdminResponsiveTabs({ tabs, activeKey, onChange, tone = "emerald", isDarkMode }) {
  const selectedTone = tones[tone] || tones.emerald;
  const mobileColumns = tabs.length <= 2 ? "grid-cols-2" : "grid-cols-3";
  return <div className={`grid ${mobileColumns} gap-1.5 px-3 py-2.5 sm:flex sm:flex-wrap sm:items-center sm:gap-2 sm:px-6 sm:py-3 ${isDarkMode ? "bg-slate-900" : "bg-slate-50/80"}`}>
    {tabs.map((tab) => {
      const Icon = tab.icon || iconForTab(tab.key);
      const isActive = activeKey === tab.key;
      return <button key={tab.key} type="button" onClick={() => onChange(tab.key)} className={`flex min-h-[48px] flex-col items-center justify-center gap-1 rounded-xl px-2 py-1.5 text-[10px] font-semibold transition sm:inline-flex sm:min-h-0 sm:flex-row sm:rounded-full sm:px-4 sm:py-2 sm:text-sm ${isActive ? `${selectedTone.active} shadow-sm` : isDarkMode ? "bg-slate-800/80 text-slate-400 hover:bg-slate-800 hover:text-slate-100" : `bg-white text-slate-500 shadow-sm ${selectedTone.idle}`}`}><Icon className="text-sm sm:text-xs" /><span>{tab.label}</span></button>;
    })}
  </div>;
}
